export const taskStatusColor = (status) =>
  status === 'Completed'
    ? 'success'
    : status === 'In Progress'
    ? 'warning'
    : status === 'New' || !status
    ? 'error'
    : 'default'

// Feed titles/summaries can carry HTML entities or tags - strip to plain text
// for searching. DOMParser rather than innerHTML so nothing in the markup runs.
export const plainText = (value) => {
  if (!value) return ''
  return (
    new DOMParser().parseFromString(value, 'text/html').body.textContent ?? ''
  )
}
